import { pipesRepository } from "@src/core/engine/pipes/pipesRepository";
import { PhysicalType } from "@src/core/engine/units/constants";
import { ValidationResult } from "@src/core/engine/validationResults/buildValidationResult";

export const pipeSizeOptions = [
  { label: "", value: "" },
  ...pipesRepository.getValveSizeOptions().map((option) => ({
    label: `DN ${option.label}`,
    value: option.id,
  })),
];

export const isPipeSizeValid = (pipeSize?: string) => {
  if (!pipeSizeOptions.some((option) => option.value === pipeSize)) {
    return buildInvalidValidationResult("pipeSize");
  }
  return true;
};

export const isFlowValid = (flow?: number | string) => {
  const num = Number(flow);
  if (isNaN(num)) return buildInvalidValidationResult("flow", "PHYS_FLOW");
  if (num < 0)
    return buildTooLowValidationResult("flow", "PHYS_FLOW", num, 0.01);
  return true;
};

export const isPowerValid = (power?: number | string) => {
  const num = Number(power);
  if (isNaN(num)) return buildInvalidValidationResult("power", "PHYS_TH_POWER");
  if (num < 0)
    return buildTooLowValidationResult("power", "PHYS_TH_POWER", num, 0.01);
  return true;
};

export const isDifferentialTemperatureValid = (
  differentialTemperature?: number | string,
) => {
  const num = Number(differentialTemperature);
  if (isNaN(num))
    return buildInvalidValidationResult(
      "differentialTemperature",
      "PHYS_DIFFTEMP",
    );
  return true;
};

const buildTooLowValidationResult = (
  path: string,
  physicalType: PhysicalType,
  value: number,
  min: number,
): ValidationResult => {
  return {
    code: "tooLow",
    constraints: {
      max: Infinity,
      min,
      physicalType,
      reference: null,
      sizeMax: "",
      sizeMin: "",
      value,
    },
    path,
    severity: "error",
    translationKey: null,
  };
};

const buildInvalidValidationResult = (
  path: string,
  physicalType: PhysicalType | null = null,
): ValidationResult => {
  return {
    code: "invalid",
    constraints: {
      max: Infinity,
      min: -Infinity,
      physicalType,
      reference: null,
      sizeMax: "",
      sizeMin: "",
      value: -1,
    },
    path,
    severity: "error",
    translationKey: null,
  };
};
